var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBtnVisible)?_c('v-btn',{staticClass:"button-base",attrs:{"depressed":"","color":"primary","loading":_vm.loading},on:{"click":_vm.btnClickHandler}},[_vm._v(" Повторно отправить ИН в ФССП ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }